module.exports = __webpack_public_path__ + "static/img/empty_404.120a25ab.png";